const initialState = {
  data: null,
}

/*
During serverside rendering, data is placed in the redux store, under keys derived from reducer names.
Without this reducer in place, we get errors.
*/
export default function reducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state
  }
}
